import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "examples/Tables/DataTable";
import { ToastContainer, toast } from "react-toastify";
import { useCallback, useEffect, useRef, useState } from "react";
import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import CountdownRow from "components/CounDown";
import ImageModal from "components/ImageModal";
import EmptyData from "components/EmptyData";
import { useSelector } from "react-redux";
import ReportGenerate from "../../Utils/reportGenerate";
import DowloadReport from "Utils/dowloadReport";
import UserConnectCheck from "Utils/UserConnectCheck";
import BatteryStatusChip from "layouts/Escort/BatteryStatusChip";
import apiClient from "../../Utils/apiClient";
import socketService from "../../socket/newsocketService";
import WellbeingMenu from "Utils/wellbeingAction";

function VirtualHomeCheck() {
  const [rows, setRows] = useState([]);
  const getUserState = useSelector((state) => state?.data?.getUserState);
  console.log("[VirtualHomeCheck] component render", { getUserState });

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [openWellBeingMod, setWellBeingMod] = useState(false);

  const [modData, setModData] = useState([]);
  const profileCacheRef = useRef(new Map());

  const closeModal = useCallback(
    (index) => {
      setWellBeingMod(false);
    },
    [openWellBeingMod]
  );

  const [processedSosIds, setProcessedSosIds] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [onClickImageData, setOnClickImageData] = useState("");
  const [checkSuperAdmin, setCheckSuperAdmin] = useState(null);
  const [adminState, setAdminState] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const handleImageClick = (url) => {
    setIsModalOpen(true);
    setOnClickImageData(url);
  };

  const deleteItem = async (userId, id) => {
    console.log("[VirtualHomeCheck] delete clicked", { userId, id });
    setRows((prevRows) => prevRows.filter((row) => row?.virtualHomeCheckId !== id));
    toast.info("Delete is not wired to a backend route yet.", {
      autoClose: 3000,
      position: toast.POSITION.TOP_CENTER,
    });
  };

  const fetchUserProfile = useCallback(async (userId) => {
    if (!userId) {
      return null;
    }

    if (profileCacheRef.current.has(userId)) {
      return profileCacheRef.current.get(userId);
    }

    try {
      const response = await apiClient.get(`/users/${userId}`);
      const profile = response?.data || response || null;
      profileCacheRef.current.set(userId, profile);
      return profile;
    } catch (error) {
      console.log("[VirtualHomeCheck] user profile fetch error", {
        userId,
        error,
      });
      return null;
    }
  }, []);

  const buildVirtualHomeCheckRow = useCallback(
    (record, index) => {
      const payload = record?.payload || {};

      const userId = record?.userId || payload?.userId || "";
      const socketId = record?.socketId || payload?.socketId || null;
      const userName =
        record?.userName ||
        payload?.userName ||
        payload?.Name ||
        payload?.fullName ||
        "Unknown User";
      const userEmail =
        record?.userEmail ||
        payload?.userEmail ||
        payload?.email ||
        "";
      const userImage = record?.userImage || payload?.userImage || "";
      const state = record?.state || payload?.state || "";
      const batteryIndicator =
        record?.batteryIndicator ??
        payload?.BatteryIndicator ??
        payload?.batteryIndicator ??
        0;

      return {
        SR: index + 1,
        virtualHomeCheckId:
          record?._id || record?.id || `${userId || "unknown"}-${record?.createdAt || index}`,
        userId,
        userEmail,
        userImage: (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img
              onClick={() => handleImageClick(userImage)}
              src={userImage}
              alt="No picture"
              style={{
                backgroundSize: "cover",
                width: "50px",
                height: "50px",
                borderRadius: "50%",
              }}
            />
            <span
              style={{
                marginTop: "5px",
                fontSize: "12px",
                textAlign: "center",
              }}
            >
              {userName}
            </span>
          </div>
        ),
        User_Connected: <UserConnectCheck status={socketId} />,
        Location_Type:
          payload?.locationType || payload?.Location_Type || payload?.checkInType || "N/A",
        Location: (
          <h6 className="fw-bold btn btn-sm btn-warning text-dark">
            {payload?.Place || payload?.place || payload?.currentLocTxt || "N/A"}
          </h6>
        ),
        additionaInfo:
          payload?.additionalInfo || payload?.additionaInfo || payload?.notes || "N/A",
        time: payload?.Time || payload?.time || "N/A",
        interval: payload?.Interval || payload?.interval || "N/A",
        Geo_Fencing: payload?.Parameter || payload?.geoFencing || "N/A",
        Mode: payload?.checkInType || payload?.Mode || "N/A",
        Battery_Indicator: (
          <BatteryStatusChip status={(Number(batteryIndicator || 0) * 100).toFixed(2)} />
        ),
        cd: (
          payload?.Date && payload?.Time ? (
            <CountdownRow
              key={index}
              date={String(payload?.Date).replace(/\s+/g, "")}
              time={payload?.Time}
              interval={parseIntervalToMinutes(payload?.Interval)}
            />
          ) : (
            "--"
          )
        ),
        Date: payload?.Date || payload?.date || "N/A",
        State: state,
        Action: (
          <Button
            onClick={() => {
              setModData(payload);
              setWellBeingMod(true);
            }}
            style={{ padding: 7, backgroundColor: "#f2f2f2" }}
          >
            <VisibilityIcon />
          </Button>
        ),
        selVeh: (
          <Button
            onClick={() => {
              handleImageClick(payload?.userVehicle || userImage);
            }}
            style={{ padding: 0 }}
            className=" ms-1 btn btn-secondary btn-sm px-1 p-0 m-0 bg-secondary text-warning btn-sm"
          >
            Location Id
          </Button>
        ),
        Delete: (
          <button
            className="btn btn-danger"
            onClick={() => deleteItem(userId, record?._id || record?.id)}
          >
            Delete
          </button>
        ),
        map: <Link to={`/locate/${userId}?userData=truck`}>Track</Link>,
        report: <ReportGenerate props={payload} />,
        download: <DowloadReport userId={userId} />,
        action: <WellbeingMenu props={payload} />,
        rawRecord: record,
      };
    },
    [],
  );

  const loadVirtualHomeCheck = useCallback(async () => {
    const currentAdminData = JSON.parse(localStorage.getItem("user") || "{}");
    const adminStateValue = currentAdminData?.state || "";
    const isSuperAdmin = currentAdminData?.superAdmin;
    const selectedState =
      getUserState === "" || getUserState === "All State" ? "" : getUserState;
    const stateFilter = isSuperAdmin ? selectedState : adminStateValue;

    console.log("[VirtualHomeCheck] loading backend data...", {
      selectedState: getUserState,
      adminState: adminStateValue,
      isSuperAdmin,
      stateFilter: stateFilter || "ALL",
      api: "/virtual-travel-guard",
      socketEvents: ["virtualtravelguard", "wellbeingescort"],
    });

    setCheckSuperAdmin(isSuperAdmin);
    setAdminState(adminStateValue);
    setLoading(true);

    try {
      const params = {
        page: 1,
        limit: 500,
        includeHomeCheck: true,
      };

      if (stateFilter) {
        params.state = stateFilter;
      }

      const response = await apiClient.get("/virtual-travel-guard", { params });
      const records = Array.isArray(response?.data) ? response.data : [];

      console.log("[VirtualHomeCheck] api response", {
        count: records.length,
        pagination: response?.pagination || null,
      });

      const mappedRows = records
        .filter((r) => r.sourceType === "virtualhomecheck")
        .map((record, index) => buildVirtualHomeCheckRow(record, index));

      const filteredRows = mappedRows.filter((row) => {
        const rowState = row?.State || "";
        return !stateFilter || rowState === stateFilter || getUserState === "All State";
      });

      filteredRows.sort((a, b) => {
        const left = b?.rawRecord?.createdAt || b?.rawRecord?.updatedAt || 0;
        const right = a?.rawRecord?.createdAt || a?.rawRecord?.updatedAt || 0;
        return left - right;
      });

      console.log("[VirtualHomeCheck] api filtered result", {
        finalRows: filteredRows.length,
        sample: filteredRows[0] || null,
      });

      setRows(filteredRows.reverse());
    } catch (error) {
      console.log("[VirtualHomeCheck] api fetch error", error);
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [buildVirtualHomeCheckRow, getUserState]);

  useEffect(() => {
    const user = localStorage.getItem("user");
    console.log("[VirtualHomeCheck] page mounted", {
      hasLocalUser: Boolean(user),
      selectedState: getUserState,
    });

    if (!user) {
      navigate("/authentication/sign-in");
      return;
    }

    socketService
      .initializeSocket()
      .then(() => {
        console.log("[VirtualHomeCheck] socket connected");
      })
      .catch((error) => {
        console.log("[VirtualHomeCheck] socket connect error", error);
      });

    loadVirtualHomeCheck();
  }, [getUserState, loadVirtualHomeCheck, navigate]);

  useEffect(() => {
    console.log("[VirtualHomeCheck] socket listeners registering");

    const refreshFromSocket = (payload) => {
      console.log("[VirtualHomeCheck] socket event received", payload);
      loadVirtualHomeCheck();
    };

    socketService.on("virtualtravelguard", refreshFromSocket);
    socketService.on("wellbeingescort", refreshFromSocket);

    return () => {
      socketService.off("virtualtravelguard", refreshFromSocket);
      socketService.off("wellbeingescort", refreshFromSocket);
    };
  }, [loadVirtualHomeCheck]);

  function addMinutesToTime(inputTime, minutesToAdd) {
    const timeComponents = inputTime.match(/^(\d{1,2}):(\d{2})\s?([APap][Mm])$/);
    if (!timeComponents) {
      throw new Error("Invalid time format. Please use 'hh:mm AM/PM' format.");
    }

    let [, hours, minutes, amPm] = timeComponents;
    hours = parseInt(hours, 10);
    minutes = parseInt(minutes, 10);

    if (amPm.toLowerCase() === "pm" && hours !== 12) {
      hours += 12;
    } else if (amPm.toLowerCase() === "am" && hours === 12) {
      hours = 0;
    }
    const parsedTime = new Date();
    parsedTime.setHours(hours, minutes);
    parsedTime.setMinutes(parsedTime.getMinutes() + minutesToAdd);
    const formattedHours = parsedTime.getHours() % 12 || 12;
    const formattedMinutes = parsedTime.getMinutes();
    const formattedAmPm = parsedTime.getHours() >= 12 ? "PM" : "AM";

    return `${formattedHours}:${String(formattedMinutes).padStart(2, "0")} ${formattedAmPm}`;
  }

  function parseIntervalToMinutes(intervalString) {
    if (!intervalString) return 0;

    const lower = intervalString.toLowerCase();

    const hourMatch = lower.match(/(\d+)\s*hour/);
    const minuteMatch = lower.match(/(\d+)\s*minute/);

    const hours = hourMatch ? parseInt(hourMatch[1]) : 0;
    const minutes = minuteMatch ? parseInt(minuteMatch[1]) : 0;

    return hours * 60 + minutes;
  }

  const columns = [
    { Header: <span style={{ color: "blue" }}>SR</span>, accessor: "SR", align: "center" },

    {
      Header: <span style={{ color: "blue" }}>Selfie</span>,
      accessor: "userImage",
      align: "center",
    },

    {
      Header: <span style={{ color: "blue" }}>Email</span>,
      accessor: "userEmail",
      align: "center",
    },
    {
      Header: <span style={{ color: "blue" }}>User Connected</span>,
      accessor: "User_Connected",
      align: "center",
    },
    {
      Header: <span style={{ color: "blue" }}>Location Type</span>,
      accessor: "Location_Type",
      align: "center",
    },
    {
      Header: <span style={{ color: "blue" }}>Location Address</span>,
      accessor: "Location",
      align: "center",
    },
    {
      Header: <span style={{ color: "blue" }}>Additional Information</span>,
      accessor: "additionaInfo",
      align: "center",
    },
    {
      Header: <span style={{ color: "blue" }}>Start Time</span>,
      accessor: "time",
      align: "center",
    },
    {
      Header: <span style={{ color: "blue" }}>Interval</span>,
      accessor: "interval",
      align: "center",
    },
    {
      Header: <span style={{ color: "blue" }}>Geo Fencing</span>,
      accessor: "Geo_Fencing",
      align: "center",
    },
    {
      Header: <span style={{ color: "blue" }}>Mode of communication</span>,
      accessor: "Mode",
      align: "center",
    },
    {
      Header: <span style={{ color: "blue" }}>Battery Indicator</span>,
      accessor: "Battery_Indicator",
      align: "center",
    },

    { Header: <span style={{ color: "blue" }}>count Down</span>, accessor: "cd", align: "center" },

    { Header: <span style={{ color: "blue" }}>Date</span>, accessor: "Date", align: "center" },

    {
      Header: <span style={{ color: "blue" }}>State</span>,
      accessor: "State",
      align: "center",
    },
    { Header: <span style={{ color: "blue" }}>View</span>, accessor: "Action", align: "center" },
    {
      Header: <span style={{ color: "blue" }}>Location Id</span>,
      accessor: "selVeh",
      align: "center",
    },
    {
      Header: <span style={{ color: "blue" }}>Delete</span>,
      accessor: "Delete",
      align: "center",
    },
    {
      Header: <span style={{ color: "blue" }}>Map Location</span>,
      accessor: "map",
      align: "center",
    },
    {
      Header: <span style={{ color: "blue" }}>Report Generate</span>,
      accessor: "report",
      align: "center",
    },
    {
      Header: <span style={{ color: "blue" }}>Download Report</span>,
      accessor: "download",
      align: "center",
    },
    {
      Header: <span style={{ color: "blue" }}>Action</span>,
      accessor: "action",
      align: "center",
    },
    // {
    //   Header: <span style={{ color: "blue" }}>virtualHomeCheckId</span>,
    //   accessor: "virtualHomeCheckId",
    //   align: "center",
    // },
  ];

  const onClose = () => {
    setIsModalOpen(false);
  };

  const filteredRows = rows.filter((row) => {
    const search = searchTerm.toLowerCase();
    const name = row?.userImage?.props?.children?.[1]?.props?.children?.toLowerCase() || "";
    const email = row?.userEmail?.toLowerCase() || "";

    return name.includes(search) || email.includes(search);
  });

  return (
    <DashboardLayout>
      <ToastContainer />
      <MDBox pt={6} pb={3}>
        <Box display="flex" justifyContent="flex-end" alignItems="center" mb={5} px={2}>
          <TextField
            label="Search by name, email"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ width: 300 }}
          />
        </Box>
        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          {loading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Loading...
            </div>
          ) : (
            <>
              <Grid item xs={12}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <MDTypography variant="h6" color="white">
                      {checkSuperAdmin
                        ? getUserState === ""
                          ? "All State "
                          : `${getUserState} State `
                        : `${adminState} State `}
                      Virtual Home Check
                    </MDTypography>
                  </MDBox>

                  <MDBox pt={3}>
                    {rows.length > 0 ? (
                      <DataTable
                        table={{ columns, rows: filteredRows }}
                        isSorted={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        noEndBorder
                      />
                    ) : (
                      <EmptyData />
                    )}
                  </MDBox>
                </Card>

                <ImageModal
                  onClickImageData={onClickImageData}
                  onClose={onClose}
                  isModalOpen={isModalOpen}
                />
                <Modal
                  open={openWellBeingMod}
                  onClose={() => setWellBeingMod(false)}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 600,
                      bgcolor: "background.paper",
                      borderRadius: 3,
                      boxShadow: 24,
                      p: 4,
                    }}
                  >
                    <Box sx={{ display: "flex", gap: 4 }}>
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="body1" component="div">
                          <strong>Type:</strong> {"Virtual Home Check"} <br />
                          <strong>Date:</strong> {modData?.Date} <br />
                          <strong>Time:</strong> {modData?.Time} <br />
                          <strong>Interval:</strong> {modData?.Interval} <br />
                          <strong>Location:</strong> {modData?.Place} <br />
                          <strong>Mode of communication:</strong> {modData?.checkInType}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          width: 220,
                          height: 220,
                          borderRadius: 2,
                          overflow: "hidden",
                          border: "1px solid #ddd",
                        }}
                      >
                        <img
                          src={modData.userSelfie}
                          alt="No image attached by user"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Modal>
              </Grid>
            </>
          )}
        </Grid>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default VirtualHomeCheck;
